import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  FormHelperText,
  Grid,
  TextField,
  Divider,
} from "@mui/material";
import LoadingBar from "../../../App/Components/LoadingBar/LoadingBar";
import DropdownComponent from "../../../App/Components/Dropdown/DropdownComponent";
import { createUser, getUsers } from "../../../App/Services/UserService";
import RightsSection from "./RightsSection";
import { callAPI } from "../../../App/Helpers/callApi";

import { useRoleSelectionState } from "../State/RoleSelectionState";
import { CRMRoles } from "../../../App/Enums/CRMRoles";
import AutoCompleteComponent from "../../../App/Components/AutoComplete/AutoComplete";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  error: {
    color: theme.palette.error.main,
  },
}));
export default function CreateModal({
  setModal,
  setShowSignifier,
  setResponseMessage,
  setShowError,
  setTableData,
  canEditCareersRoles,
  canEditCrmRoles,
}) {
  const classes = useStyles();
  const roleState = useRoleSelectionState();

  const [processing, setProcessing] = useState(false);
  const [inputError, setInputError] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [confirmPhone, setConfirmPhone] = useState("");

  const checkInput = () => {
    if (
      firstName === "" ||
      lastName === "" ||
      email === "" ||
      (phone.length > 0 && phone.length < 7)
    ) {
      setInputError(true);
      return false;
    }
    if (confirmEmail !== email || confirmPhone !== phone) {
      setInputError(true);
      return false;
    }
    return true;
  };

  const submitUser = () => {
    if (checkInput()) {
      var data = {
        User: {
          FirstName: firstName,
          LastName: lastName,
          EmailAddress: email,
          PhoneNumber: phone,
        },
        Role: {
          BaseClientId: roleState.getters.selectedClient?.id,
          ClientId: roleState.getters.selectedCareersClient?.id,
          RoleId: roleState.getters.selectedRole?.id,
          RightsFlag: roleState.getters.selectedRights,
          CRMRole: roleState.getters.selectedCRMRole.value,
        },
        SignupRoute: import.meta.env.VITE_ACTIVATE_PORTAL,
      };

      callAPI(
        createUser(data),
        "User Created",
        setShowSignifier,
        setResponseMessage,
        setShowError,
        setProcessing
      ).then(() => {
        getUsers(
          roleState.getters.isSuperAdmin,
          roleState.getters.isAdmin,
          roleState.getters.isLightAdmin,
          roleState.getters.isClientAdmin
        ).then((response) => {
          setTableData(response);
        });
        setModal(false);
      });
    }
  };

  return (
    <div className={classes.root}>
      <LoadingBar loading={processing} />
      <Grid>
        <Card>
          <CardContent>
            <FormHelperText style={{ fontWeight: "bold" }}>
              Create User
            </FormHelperText>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="First Name"
                  label="First Name"
                  variant="standard"
                  fullWidth
                  required
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  error={inputError && firstName === ""}
                  helperText={
                    inputError && firstName === "" ? "First Name Required" : ""
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Last Name"
                  label="Last Name"
                  variant="standard"
                  fullWidth
                  required
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  error={inputError && lastName === ""}
                  helperText={
                    inputError && lastName === "" ? "Last Name Required" : ""
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Email Address"
                  label="Email Address"
                  variant="standard"
                  fullWidth
                  required
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={inputError && email === ""}
                  helperText={
                    inputError && email === "" ? "Email Address Required" : ""
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Confirm Email Address"
                  label="Confirm Email Address"
                  variant="standard"
                  fullWidth
                  required
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={confirmEmail}
                  onChange={(e) => setConfirmEmail(e.target.value)}
                  error={inputError && confirmEmail !== email}
                  helperText={
                    inputError && confirmEmail !== email
                      ? "Email Addresses Must Match"
                      : ""
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Cell Phone Number"
                  label="Cell Phone Number"
                  variant="standard"
                  fullWidth
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  error={inputError && phone.length > 0 && phone.length < 7}
                  helperText={
                    inputError && phone.length > 0 && phone.length < 7
                      ? "Invalid Cell Phone Number"
                      : ""
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Confirm Cell Phone Number"
                  label="Confirm Cell Phone Number"
                  variant="standard"
                  fullWidth
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={confirmPhone}
                  onChange={(e) => setConfirmPhone(e.target.value)}
                  error={inputError && confirmPhone !== phone}
                  helperText={
                    inputError && confirmPhone !== phone
                      ? "Cell Phone Numbers Must Match"
                      : ""
                  }
                />
              </Grid>
              <FormHelperText style={{ fontWeight: "bold" }}>
                User Permissions
              </FormHelperText>
              {roleState.getters.selectedClient.hasCareers &&
              canEditCareersRoles ? (
                <>
                  <Grid item xs={12} sm={12}>
                    <Divider></Divider>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <AutoCompleteComponent
                      dropdownItems={roleState.handlers.filterRoles()}
                      propertyName="name"
                      label="Careers Role"
                      onChange={(e, value) =>
                        roleState.setters.setSelectedRole(value)
                      }
                      currValue={roleState.getters.selectedRole}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <RightsSection
                      roleId={roleState.getters.selectedRole?.id?.toUpperCase()}
                      rights={roleState.getters.selectedRights}
                      setRights={roleState.setters.setSelectedRights}
                    />
                  </Grid>
                </>
              ) : null}
              {canEditCrmRoles ? (
                <>
                  <Grid item xs={12} sm={12}>
                    <Divider></Divider>
                    <br></br>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <DropdownComponent
                      currValue={roleState.getters.selectedCRMRole}
                      items={CRMRoles}
                      property="name"
                      title="CRM Role"
                      handleChange={(value) =>
                        roleState.setters.setSelectedCRMRole(value)
                      }
                      multi={false}
                    />
                  </Grid>
                </>
              ) : null}
              <Grid
                container
                justifyContent="flex-end"
                direction="row"
                style={{ marginRight: "10px" }}
              >
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ color: "#82B288", marginTop: "20px" }}
                    type="submit"
                    variant="outlined"
                    fullWidth
                    onClick={() => setModal(false)}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ marginTop: "20px", marginLeft: "10px" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => submitUser()}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
